import { isSameSearchCriteria } from "domains/publication/reducer";
import { getTmSelectedOuterNode, getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import type { RootState } from "types/redux";

export const createInteractiveDataForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.knowledgeData.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, {
      ...getKnowledgeDataSearchCriteria(state),
      id: id,
      secondaryTopicId: getTmSelectedOuterNodeId(state),
    }),
  );

export const getKnowledgeDataSearchCriteria = (state: RootState) => state.domains.knowledgeData.searchCriteria;

export const getKnowledgeDataSearchTerm = (state: RootState) => state.domains.knowledgeData.searchCriteria.search;

export const getIsKnowledgeDataFiltered = (state: RootState) => {
  const { publication_type, search } = state.domains.knowledgeData.searchCriteria;
  return !!publication_type || !!search || !!getTmSelectedOuterNode(state)?.id;
};

export const getInteractiveDataFilterCount = (state: RootState) => {
  const { publication_type, search } = state.domains.knowledgeData.searchCriteria;
  let count = 0;
  if (publication_type) count++;
  if (search) count++;
  return count;
};
